import { FC } from "react";

const CheckBoxIcon: FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="3.5"
        stroke="url(#paint0_linear_2204_954)"
        stroke-opacity="0.6"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2204_954"
          x1="-5.96046e-07"
          y1="20"
          x2="21.9512"
          y2="17.561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3762A6" />
          <stop offset="1" stop-color="#D9329A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CheckBoxIcon;
